export interface ISignatureProps {}
export interface ISignatureState {
    fullName: string;
    email: string;
    org: string;
    location: string;
    jobTitle: string;
    workPhone: string;
    cellPhone: string;
    pronouns: string;
    isValid: boolean;
    isMobile?: boolean;
}

export interface Organization {
    color: string;
    logoEmbedded: string;
    logoUrl: string;
    name: string;
    website: string;
    hasLegalDisclaimer?: boolean;
}

export interface SignatureLocation {
    addressLine1: string;
    addressLine2: string;
    name: string;
    telephone: string;
}

const imagePath = "./images/";

export const organizations: Organization[] = [
    {
        color: "#7D4BFF",
        logoUrl: `${imagePath}MINDFULLY@2x.png`,
        logoEmbedded: require("./images/MINDFULLY@2x.png"),
        name: "Mindfully",
        website: "mindfully.com",
        hasLegalDisclaimer: true,
    },
];

export const defaultOrg: Organization = {
    color: "#2C2C2C",
    logoUrl: `${imagePath}transparent.png`,
    logoEmbedded: require("./images/transparent.png"),
    name: "",
    website: "",
};

export const locations: SignatureLocation[] = [
    {
        addressLine1: "",
        addressLine2: "",
        name: "No Address",
        telephone: "",
    },
    {
        addressLine1: "1251 Nilles Road, Clock Tower Place Suite 4",
        addressLine2: "Fairfield Ohio 45014 USA",
        name: "Fairfield",
        telephone: "+1 888 830 0347",
    },
    {
        addressLine1: "10290 Alliance Road",
        addressLine2: "Blue Ash Ohio 45242 USA",
        name: "VIC in Blue Ash",
        telephone: "+1 513 792 5100",
    },
];

export const defaultLocation: SignatureLocation = {
    addressLine1: "",
    addressLine2: "",
    name: "",
    telephone: "",
};
